import entityTypes from './entity-types.enum';

const templateMethodMap = {
    [entityTypes.DISPLAY_REPORTS]: 'optimizeReportTemplates',
    [entityTypes.VIDEO_REPORTS]: 'videoReportTemplates',
    [entityTypes.EVENT_LOG_REPORTS]: 'eventLogReportTemplates',
};

export default templateMethodMap;
